import { createFeatureSelector, createSelector } from '@ngrx/store';
import { FeatureFlagState } from './feature-flag.reducer';

export const featureFlagState = createFeatureSelector<FeatureFlagState>('featureFlags');

export const getIncentiveEditButtonFeatureFlag = createSelector(
  featureFlagState,
  (state: FeatureFlagState) => state.flags['crm-incentive_edit_button-toggle']
);

export const getProviderPhaseTwoFeatureFlag = createSelector(
  featureFlagState,
  (state: FeatureFlagState) => state.flags['crm-provider_phase-two']
);
